
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { BContainer, BRow, BCol } from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SelectAutocomplete from "@/components/input/SelectAutocomplete.vue";

@Component({
  components: {
    BRow,
    BContainer,
    BCol,
    ValidationObserver,
    ValidationProvider,
    SelectAutocomplete,
  },
})
export default class ModalAddMaterial extends Vue {
  modalShow = false;
  ticketId: string | null = null;

  isActiveQty = false;
  isActiveScope = false;

  qty: number | null = null;
  scope_of_work: string | null = null;


  cekQty() {
    if (this.qty !== null) {
      this.isActiveQty = true;
    } else {
      this.isActiveQty = false;
    }
  }

  cekScope() {
    if (this.scope_of_work !== null) {
      this.isActiveScope = true;
    } else {
      this.isActiveScope = false;
    }
  }
  closeModal() {
    this.modalShow = false;
    setTimeout(() => {
      this.qty = null;
      this.scope_of_work = null;
    },200);
  }
  showModal(idTicket: string) {
    this.modalShow = true;
    this.ticketId = idTicket;
  }

  saveManPower() {
    this.$emit("onSave", {
      qty: this.qty,
      scope_of_work: this.scope_of_work,
    });
    this.closeModal();
  }

}
